import {getGPUTier} from "detect-gpu";
import {MeshPhongMaterial} from "three";

export const isMobile = () => {
  return "ontouchstart" in document.documentElement;
};

export const isAndroid = () => Boolean(navigator.userAgent.match(/Android/i));

export const isIos = () =>
  Boolean(navigator.userAgent.match(/iPhone|iPad|iPod/i));

export const convertToPhongMaterials = (materials: any) => {
  Object.keys(materials).forEach((k) => {
    if (materials[k].map) materials[k].map.anisotropy = 8;

    materials[k] = new MeshPhongMaterial({
      map: materials[k].map,
      color: materials[k].color,
      shininess: 0,
    });
  });
};

export function getGpuTier() {
  const GPUTier = getGPUTier();
  const tier = Number(GPUTier.tier.split("_").pop());
  return tier;
}

// export interface CampaignData {
//   campaignDays: {
//     activeDays: number;
//     positions: {
//       tenants: string[];
//       point: [number, number, number];
//     }[];
//     texture: string;
//   }[];
// }

// export const apiBase = "https://cms.latorreoutletzaragoza.com";

// const fetchGiftPosition = async (): Promise<CampaignData> => {
//   const res = await fetch(`${apiBase}/_/items/ivs`, {
//     method: "GET",
//     headers: {
//       "Content-Type": "application/json",
//     },
//   });

//   const jsonRes = await res.json();

//   const campaign: CampaignData = jsonRes.data[0].gift_position;

//   return campaign;
// };

// export const firstDay = new Date("Sep 22, 2020").getTime();

// export async function useCampaignDay() {
//   const today = new Date().getTime();
//   // day = 24 * (hours = 60 * (minutes = 60 * (seconds = 1000 * miliseconds))))
//   const daysSinceCampaignStart = Math.floor(
//     (today - firstDay) / (1000 * 60 * 60 * 24)
//   );

//   const calculateCampaginDays = (c: CampaignData): number => {
//     let campaignDay = -1;
//     let accumulatedCampaignDays = 0;
//     do {
//       campaignDay++;
//       accumulatedCampaignDays += c.campaignDays[campaignDay].activeDays;
//     } while (daysSinceCampaignStart > accumulatedCampaignDays - 1);
//     return campaignDay;
//   };

//   const campaign = await fetchGiftPosition();
//   const campaignDay = calculateCampaginDays(campaign);
//   return campaign.campaignDays[campaignDay];
// }
